<template>
  <div class="office-box">
    <div class="office-desc">
      <p class="mb5">我们是追求品质与力求不断超越自己的团队</p>
      <p>每一位团队成员也是亲密的伙伴，与公司一起成长与发展，我们尊重每次合作的机会与挑战，不断精进，力求完美。</p>
    </div>
    <div class="office-list">
      <h2 class="branch">招聘岗位</h2>
      <ul class="branch-list">
        <li class="office-branch" v-for="(item, index) in officeList" :key="index">
          <p class="title">{{ item.branchTitle }}</p>
          <ul>
            <li class="branch-item" v-for="( branch, ind ) in item.itemList" :key="ind">
              <div class="flex flex-align-center flex-between branch-title">
                <div class="flex-align-center branch-title-right">
                  <i class="mr10">{{ branch.itemIndex }}</i>
                  <p class="">{{ branch.itemTitle }}</p>
                  <span class="branch-number"> {{ branch.itemNum }}</span>
                </div>
                <div class="branch-title-left">
                  <p @click="branchClick(index, ind)" v-if="branch.isActive">收起 <i class="el-icon-arrow-down"></i></p>
                  <p @click="branchClick(index, ind)" v-else>查看详情 <i class="el-icon-arrow-up"></i></p>
                </div>
              </div>
              <div class="branch-content animate__animated animate__fadeIn" v-if="branch.isActive">
                <p class="branch-content-title mb10">任职要求：</p>
                <ul>
                  <li class="" v-for="(cont, i) in branch.branchContentList" :key="i">
                    <span class="mr10">{{ cont.index }}</span> {{ cont.desc }}
                  </li>
                </ul>
                <p class="branch-content-title mb10 mt20">岗位职责：</p>
                <ul>
                  <li v-for="( job, j ) in branch.jobList" :key="j" class="mb10">
                    <span class="mr10">{{ job.index }}</span> {{ job.desc }}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isActive: true,
      officeList: [
        {
          branchTitle: '开发部门：',
          itemList: [
            {
              itemIndex: '01',
              itemTitle: '软件测试工程师',
              itemNum: '1人',
              isActive: true,
              branchContentList: [
                {
                  index: 1,
                  desc: '能够熟练操作电脑，熟悉常用的测试工具；'
                },
                {
                  index: 2,
                  desc: '熟悉Windows、Android、IOS等主流平台特性和使用'
                },
                {
                  index: 3,
                  desc: '熟练使用抓包工具，熟悉常用的网络分析工具；'
                },
                {
                  index: 4,
                  desc: '善于沟通，具有一定的解决问题能力和快速上手学习能力；'
                },
              ],
              jobList: [
                {
                  index: 1,
                  desc: '负责公司网站、客户端、小程序等相关产品的测试工作；'
                },
                {
                  index: 2,
                  desc: '整理测试用例并执行相关操作；'
                },
              ]
            },
            {
              itemIndex: '02',
              itemTitle: 'Python开发工程师',
              itemNum: '2人',
              isActive: true,
              branchContentList: [
                {
                  index: 1,
                  desc: '精通 Python 语言，熟悉面面向对象设计和编程，3-5 年工作经验;'
                },
                {
                  index: 2,
                  desc: '精通 PyQt 编程;精通 MVC 设计交互及 QTWidget 布局、绘图;'
                },
                {
                  index: 3,
                  desc: '熟练使用抓包工具，熟悉常用的网络分析工具；'
                },
                {
                  index: 4,
                  desc: '熟练使用 Git 进行代码管理;'
                },
                {
                  index: 5,
                  desc: '善于沟通，具有一定的解决问题能力和快速上手学习能力;'
                },
              ],
              jobList: [
                {
                  index: 1,
                  desc: '负责使用 Python 语言和相关框架开发公司渲染 PC 客户端。'
                },
                {
                  index: 2,
                  desc: '负责相关软件、后台服务程序开发及公司各类平台级产品的架构设计'
                },
                {
                  index: 3,
                  desc: '建立和完善开发文档;'
                },
              ]
            },
            {
              itemIndex: '03',
              itemTitle: 'UI设计师',
              itemNum: '2人',
              isActive: true,
              branchContentList: [
                {
                  index: 1,
                  desc: '美术及相关设计专业专科及以上；'
                },
                {
                  index: 2,
                  desc: '熟练使用 Photoshop 、Sketch，AI 等软件；'
                },
                {
                  index: 3,
                  desc: '善于创新，对视觉构成、排版和色彩有敏锐的观察力及分析能力；'
                },
                {
                  index: 4,
                  desc: '良好的沟通能力和前后端配合能力，注重团队高效协作；'
                },
                {
                  index: 5,
                  desc: '简历中必附上能够展现个人能力的作品集或链接；'
                },
              ],
              jobList: [
                {
                  index: 1,
                  desc: '负责公司官网、桌面客户端等产品的设计工作；'
                },
                {
                  index: 2,
                  desc: '基于对产品的良好理解能力，完成产品的视觉概念设计；'
                },
                {
                  index: 3,
                  desc: '针对不同的平台，灵活地调整设计方案；'
                },
              ]
            },
          ]
        },
        {
          branchTitle: '云渲染部门：',
          itemList: [
            {
              itemIndex: '04',
              itemTitle: '渲染技术支持(TD)',
              itemNum: '1人',
              isActive: true,
              branchContentList: [
                {
                  index: 1,
                  desc: '熟练使用 3DSMax、C4D、Maya、Houdini 等3D制作软件；'
                },
                {
                  index: 2,
                  desc: '熟悉 Python、Mel 等脚本开发语言；'
                },
                {
                  index: 3,
                  desc: '熟悉计算机硬件、网络、存储等相关知识；'
                }
              ],
              jobList: [
                {
                  index: 1,
                  desc: '负责渲染农场有关 Maya/Houdini 等的技术支持与维护；'
                },
                {
                  index: 2,
                  desc: '负责与渲染管理系统研发部门的技术沟通；'
                },
                {
                  index: 3,
                  desc: '负责渲染测试场景的制作与测试分析；'
                },
                {
                  index: 4,
                  desc: '负责渲染农场软件环境的更新维护，和管理流程的制定维护；'
                },
                {
                  index: 5,
                  desc: '负责渲染调度工程师的技术培训；'
                },
              ]
            },
            {
              itemIndex: '05',
              itemTitle: '渲染调度工程师',
              itemNum: '若干',
              isActive: true,
              branchContentList: [
                {
                  index: 1,
                  desc: '学历不限，动画、数字媒体、设计等图像相关专业方向优先，了解 3DMAX，MAYA 等常用的三维制作软件；'
                },
                {
                  index: 2,
                  desc: '耐心细致、较强的沟通能力、协作精神、客户服务意识，打字速度不低于 60 字每分钟；'
                }
              ],
              jobList: [
                {
                  index: 1,
                  desc: '调度管理大规模服务器集群，协助客户完成影视动画渲染任务；'
                },
                {
                  index: 2,
                  desc: '安装维护服务器集群软件环境，根据业务需求更新软件；'
                },
                {
                  index: 3,
                  desc: '记录任务过程中信息，管理任务日志；'
                },
                {
                  index: 4,
                  desc: '协助技术支持部门做好渲染技术支持工作、硬件运维部门调试硬件环境以及软件开发部门测试部署软件；'
                },
                {
                  index: 5,
                  desc: '检查图像结果是否完整，正确；'
                },
                {
                  index: 6,
                  desc: '反馈客户需求到销售部门；'
                },
              ]
            },
          ]
        },
        {
          branchTitle: '销售部门：',
          itemList: [
            {
              itemIndex: '06',
              itemTitle: '大客户销售经理',
              itemNum: '若干',
              isActive: true,
              branchContentList: [
                {
                  index: 1,
                  desc: '贯彻执行公司的销售策略，完成公司要求的销售指标；'
                },
                {
                  index: 2,
                  desc: '负责定期和不定期拜访各渠道重点客户，及时了解和处理问题；'
                },
                {
                  index: 3,
                  desc: '带领团队开发新市场和新客户，收集和分析市场及竞争对手情况，制定有效的行动计划；'
                },
                {
                  index: 4,
                  desc: '维护良好的客户关系，及时处理客户遇到的问题；'
                },
              ],
              jobList: [
                {
                  index: 1,
                  desc: '熟悉销售项目运作流程，具有售前咨询、方案提议、需求洽谈、报价、谈判、签约等工作经验，优先；'
                },
                {
                  index: 2,
                  desc: '有影视、动画制作公司和有文化创意产业工作背景优先考虑；'
                },
                {
                  index: 3,
                  desc: '反应敏捷、表达能力强，具有较强的沟通能力及交际技巧，具有亲和力；'
                },
                {
                  index: 4,
                  desc: '具备一定的市场分析及判断能力，良好的客户服务意识；'
                },
                {
                  index: 5,
                  desc: '性格热情外向、诚信正直、热爱销售行业、工作目标性强；'
                },
                {
                  index: 6,
                  desc: '工作抗压能力强，具有强烈的竞争意识；'
                },
                {
                  index: 7,
                  desc: '勇于挑战高目标和高薪酬，不断提升、完善和实现自我；'
                },
              ]
            }
          ]
        },
      ]
    }
  },
  methods: {
    branchClick (index, ind) {
      this.officeList[index].itemList[ind].isActive = !this.officeList[index].itemList[ind].isActive
    }
  },
}
</script>